export default {
	instance_without_cnpj: "Não foi possível identificar o CNPJ da sua instância.",
	customer_not_found: "Não foi possível encontrar seu cadastro no sistema de pagamentos.",
	instance_not_found: "Não foi possível encontrar sua instância no sistema de pagamentos."
}
